import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-61fffcee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "header-row cm-align-center" }
const _hoisted_3 = { class: "cm-ui-ml10" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "description-row cm-ui-ml20"
}
const _hoisted_6 = {
  key: 2,
  class: "team-list-wrap"
}
const _hoisted_7 = { class: "team-list-header" }
const _hoisted_8 = { class: "team-list el-card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1789439235824",
  class: "icon",
  viewBox: "0 0 1445 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "9521",
  width: "48",
  height: "48"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1048.094118 512c99.749647 0 179.983059-81.92 179.983058-182.874353 0-100.894118-80.233412-182.814118-179.983058-182.814118s-180.705882 81.92-180.705883 182.814118c0 100.954353 80.956235 182.874353 180.705883 182.874353z m-542.117647-73.125647c119.988706 0 216.124235-98.002824 216.124235-219.437177S625.965176 0 505.976471 0 289.129412 98.002824 289.129412 219.437176s96.858353 219.437176 216.847059 219.437177z m542.117647 219.437176c-132.276706 0-397.552941 67.282824-397.552942 201.125647v91.437177c0 40.237176 32.527059 73.125647 72.282353 73.125647h650.541177c39.755294 0 72.282353-32.888471 72.282353-73.125647v-91.437177c0-133.842824-265.276235-201.185882-397.552941-201.185882z m-542.117647-73.185882c-168.417882 0-505.976471 85.594353-505.976471 256v109.748706C0 991.111529 32.527059 1024 72.282353 1024h433.694118v-164.562824c0-62.162824 23.853176-171.188706 171.309176-253.831529-62.885647-13.131294-123.602824-20.48-171.309176-20.48z",
    fill: "var(--cm-color-primary)",
    opacity: ".5",
    "p-id": "9522"
  })
], -1))
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 3,
  class: "tips-row cm-align-center cm-ui-mt10"
}
const _hoisted_12 = { class: "cm-ui-ml5" }
const _hoisted_13 = { class: "operate-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_SmsVerify = _resolveComponent("SmsVerify")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modal: _ctx.modal,
      "append-to-body": "",
      "custom-class": "delete-user-wrap",
      title: _ctx.$t('deleteUser.dialogTitle'),
      "model-value": _ctx.modelValue,
      "show-close": "",
      width: 660,
      onClose: _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CmSvgIcon, {
              name: "assets/icons/info-1",
              size: 18
            }),
            _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.$t('deleteUser.confirmDeleteAccount')), 1)
          ]),
          (_ctx.teamList.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "description-row",
                innerHTML: _ctx.$t('deleteUser.superAdminWarning')
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('deleteUser.normalUserWarning')), 1)),
          (_ctx.teamList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('deleteUser.teamsToBeDisbanded')), 1),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "team-item",
                      key: index
                    }, [
                      _hoisted_9,
                      _createElementVNode("div", {
                        class: "team-name",
                        title: item.name
                      }, _toDisplayString(item.name), 9, _hoisted_10)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.teamList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_CmSvgIcon, {
                  name: "assets/icons/warn-border-gray",
                  monochrome: "",
                  size: 18
                }),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('deleteUser.transferAdminTip')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _ctx.handleClose
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('deleteUser.cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "danger",
              onClick: _ctx.deleteUser
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('deleteUser.confirmDelete')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modal", "title", "model-value", "onClose"]),
    _createVNode(_component_SmsVerify, {
      modelValue: _ctx.smsVerifyVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.smsVerifyVisible) = $event)),
      "confirm-button-text": _ctx.$t('deleteUser.confirmDeleteSms'),
      "use-current-phone": "",
      onConfirm: _ctx.confirmDeleteUser
    }, null, 8, ["modelValue", "confirm-button-text", "onConfirm"])
  ], 64))
}